import { render, staticRenderFns } from "./CreateContentButton.vue?vue&type=template&id=b4ecdd14&scoped=true"
import script from "./CreateContentButton.vue?vue&type=script&lang=js"
export * from "./CreateContentButton.vue?vue&type=script&lang=js"
import style0 from "./CreateContentButton.vue?vue&type=style&index=0&id=b4ecdd14&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b4ecdd14",
  null
  
)

export default component.exports